import React, { useEffect, useMemo } from 'react';

import Icon from 'components/lib/ui/Icon';

import useEventCallback from 'common/lib/hooks/useEventCallback';
import { useCommandRegistry } from 'lib/commands/context';
import type { MonarchCommandGroup } from 'lib/commands/types';

const GROUP: MonarchCommandGroup = 'actions';

type UseTransactionCommandsOptions = {
  toggleSummaryColumnVisibility: () => void;
};

export const useTransactionsRouteCommands = ({
  toggleSummaryColumnVisibility,
}: UseTransactionCommandsOptions) => {
  const { registerCommand } = useCommandRegistry();
  const toggleSummaryColumnShortcut = useMemo(() => [']'], []);
  const toggleSummaryColumn = useEventCallback(() => {
    toggleSummaryColumnVisibility();
  });

  useEffect(() => {
    const unbindCommand = registerCommand({
      group: GROUP,
      id: 'transactions.toggle-summary-column',
      label: 'Toggle summary column',
      action: toggleSummaryColumn,
      keys: toggleSummaryColumnShortcut,
      icon: <Icon name="sidebar-right" />,
    });
    
    return () => {
      unbindCommand();
    };
  }, [registerCommand, toggleSummaryColumn, toggleSummaryColumnShortcut]);

  return {
    toggleSummaryColumnShortcut,
  };
};
